import React,{ useEffect,useState } from 'react'
import { getSupermarketCategoryApi, RemovemarketCategoryAPI } from '../../../Api/PanelAdminServices'
import { errorToast, succToast } from '../../../Utils/Toast/Toast'
import TableFixedPage from '../../TableFixedPage/TableFixedPage'
import { Modal } from "react-bootstrap";
import CategoryLevelTwoTable from '../../Tables/Category/CategoryLevelTwoTable/CategoryLevelTwoTable'
import Style from './LevelTwoCategoryListContainer.module.scss'
import EditSecondLevelCategory from '../../Modal/Information/EditSecondLevelCategory/EditSecondLevelCategory';
const LevelTwoCategoryListContainer = () => {
    const[category,setCategory]=useState([])
    const [rawInfo, setRawInfo] = useState([]);
    const [modalEditShow, setModalEditShow] = useState(false);

  useEffect(()=>{
    getMarketCategory()
  },[])

  const getMarketCategory=async()=>{ 
    getSupermarketCategoryApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setCategory(res.category)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  }

  const btnHandler = (id, info) => {
    setRawInfo(info);
    if (id === 1) {
      let id={
        id:info.key
      }
      RemovemarketCategoryAPI(id,res=>{
        if(res.status===1){
          succToast(res.message)
        }else{
          errorToast(res.message)
        }
      })
      getMarketCategory()
    } else if (id === 2) {
      setModalEditShow(true)
    }
  };

  const closeModals=()=>{
    setModalEditShow(false)
  }
  let categoryFirst = [];
  category.forEach((val) => {
    if (val.parent !== "2") {
      categoryFirst.push(val);
    }
  });
  const data =
    categoryFirst &&
    categoryFirst.map((item) => {
      return {
        key: item.id,
        namePersian: item.category,
        nameEnglish: item.category_english,
        categoryFee:item.category_fee,
        firstLevelCategory:item.parent_category,
        parent:item.parent,
        count:item.count
      };
    });
    const TitleStyle = {
      width: "100%",
      color: "#c20c64",
      textAlign: "center",
    }; 
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"لیست دسته بندی سطح دوم فروشگاه"} />
      <Modal show={modalEditShow} onHide={closeModals}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>ویرایش دسته بندی سطح اول</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditSecondLevelCategory category={category} info={rawInfo} setModalEditShow={setModalEditShow} getMarketCategory={getMarketCategory}/>
        </Modal.Body>
      </Modal>
      <CategoryLevelTwoTable data={data} btnHandler={btnHandler}/>
    </div>
  );
}

export default LevelTwoCategoryListContainer